import React from "react";
import "./login.styles.css";

import { Input, message, Form, Icon, Checkbox, Button, Modal } from "antd";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import Logo from "../../assets/logo.png";
import bg from "../../assets/Login_Bg_Pattern.png";

import { SignOutAPI } from "../../auth/utils";
import { withRouter } from "react-router-dom";

import {
  setUserLoggedStatus,
  setAccessToken,
  setRefreshToken,
  setUserRBACDetails,
  setAllUsers,
  setAllBranches,
  setReportData,
} from "../../redux/user/user.actions";

///////////////////////////////////////////////////////////
//#region arrival entry optimization actions and selectors.
import {
  saveAllVarietyInfo,
  setArrivalData,
  setAllMandis,
  setBranches,
  setRegions,
  setHubs,
  setMandis,
  setVarieties,
  setRemainingVarietyList,
  setHubVarieties,
  setRemainingHubVarietyList,
  setBranchID,
  setRegionID,
  setHubID,
  setMandiID,
} from "../../redux/arrival-entry/arrival-entry.actions";
import {
  selectArrivalData,
  selectSummaryScreenVisibility,
  selectBranches,
  selectRegions,
  selectHubs,
  selectMandis,
  selectVarieties,
  selectAllVarietyInfo,
  selectHubVarieties,
  selectBranchID,
  selectRegionID,
  selectHubID,
  selectMandiID,
} from "../../redux/arrival-entry/arrival-entry.selectors";
import { setCurrentArrivalScreen } from "../../redux/map/map.actions";
import { selectCurrentArrivalScreen } from "../../redux/map/map.selectors";
//#endregion
///////////////////////////////////////////////////////////

import {
  setRollUp,
  setRemarks,
  setHubTableData,
  setHubDataPostFOR,
  setDecisionBranches,
  setDecisionRegions,
  setDecisionVarieties,
  setSelectedBranchID,
  setSelectedRegionID,
  setSelectedVarietyID,
} from "../../redux/buying-decision/buying-decision.actions";

import {
  selectHubTableData,
  selectDecisionBranches,
  selectDecisionRegions,
  selectDecisionVarieties,
  selectSelectedBranchID,
  selectSelectedRegionID,
  selectSelectedVarietyID,
} from "../../redux/buying-decision/buying-decision.selectors";

import API from "../../api";
import ForgotPassword from "../../components/forgot-password/forgot-password.component";
import { encrypt } from "../../services/generic-apis";
import { QRCodeCanvas } from "qrcode.react";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

/**
 * @description The form component for logging in.
 * @component
 * @memberof App
 */
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      open: false,
      isLoading: false,
      qrModal: false,
      mfa_configured: 0,
      mfa_enabled: 0,
      qrCode: "",
    };
  }
  componentDidMount() {
    loadCaptchaEnginge(6);
  }
  handleShow = (status) => {
    this.setState({ isLoading: true });
    if (status) {
      API.post(
        "/generate_otp",
        { user_name: this.props.form.getFieldValue("username") },
        {}
      )
        .then((response) => {
          if (response.status) {
            this.setState({ open: status });
          } else {
            message.error("Something went wrong, please try again.");
          }
        })
        .catch((err) => {
          if (err.response) message.error(err.response.data.message);
          else message.error("Something went wrong, please try again.");
        });
    } else this.setState({ open: status });
  };
  saveModalFormRef = (ref) => {
    this.modalFormRef = ref;
  };

  postSubmitData = (values, setUserLoggedStatus, setUserRBACDetails) => {
    const userPostData = {
      username: encrypt(values.username),
      password: encrypt(values.password),
      totp_token: values.totp,
      mfa_configured: values.totp && true,
    };

    API.post("/login", userPostData, {})
      .then((response) => {
        //console.log("USER RESPONSE :", response.data);
        if (response.status) {
          // reset the input fields after successful login
          this.props.form.resetFields();

          //changing the state to rerender app.js to redirect. state is passed to app.js from redux.
          setUserLoggedStatus(true);
          // localStorage.setItem(
          //   "percentage",
          //   response.data.data.min_max_range
          // );
          // rerouting to home.
          localStorage.setItem("isLogged", true);
          // this.props.history.push("/home");

          localStorage.setItem("userName", response.data.data.name);
          localStorage.setItem(
            "passwordExpired",
            response.data.data.password_expired
          );

          localStorage.setItem("accessToken", response.data.data.access_token);
          localStorage.setItem(
            "refreshToken",
            response.data.data.refresh_token
          );
          this.props.setAccessToken(response.data.data.access_token);
          this.props.setRefreshToken(response.data.data.refresh_token);
          //console.log("access token ", response.data.data.access_token );
          localStorage.setItem(
            "accessTokenExpiry",
            response.data.data.access_token_expiry
          );
          localStorage.setItem(
            "refreshToken",
            response.data.data.refresh_token
          );
          localStorage.setItem(
            "refreshTokenExpiry",
            response.data.data.refresh_token_expiry
          );

          localStorage.setItem(
            "logoutTimeStamp",
            Math.round(new Date().getTime() / 1000) +
              response.data.data.refresh_token_expiry
          );

          //#region handling RBAC

          if (
            response.data.data.role_id &&
            response.data.data.user_territories
          ) {
            localStorage.setItem("roleID", response.data.data.role_id);
            localStorage.setItem(
              "user_features",
              response.data.data.user_features
            );
            localStorage.setItem(
              "userTerritories",
              response.data.data.user_territories
            );
            localStorage.setItem(
              "location_access",
              response.data.data.location_access.map(
                (item) => item.feature_code
              )
            );
            localStorage.setItem(
              "non_location_access",
              response.data.data.non_location_access.map(
                (item) => item.feature_code
              )
            );
            setUserRBACDetails(
              response.data.data.role_id,
              response.data.data.name,
              response.data.data.user_territories,
              response.data.data.location_access.map(
                (item) => item.feature_code
              ),
              response.data.data.non_location_access.map(
                (item) => item.feature_code
              ),
              response.data.data.user_features
            );
          } else {
            setUserRBACDetails(0, "", [], [], [], []);
          }
          //#endregion
        }
      })
      .catch((err) => {
        if (err) {
          if (err.response) message.error(err.response.data.message);
          else {
            message.error("Server unavailable. Please try again later.");
          }
          if (err.response?.data?.hasOwnProperty("mfa_enabled")) {
            this.setState({
              qrCode: err.response.data.totp_uri,
              mfa_enabled: err.response.data.mfa_enabled,
              qrModal: true,
            });
          }
        } else {
          message.error("Server unavailable. Please try again later.");
        }
      });
  };

  handleSubmit = (e) => {
    const {
      setUserLoggedStatus,
      // history,
      setUserRBACDetails,
    } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      //if validated, call the login post api
      if (!validateCaptcha(values.captcha)) {
        this.props.form.resetFields("captcha")
        message.error("Please enter valid captcha!");
        return;
      }
      if (!err && values.username && values.password) {
        this.postSubmitData(values, setUserLoggedStatus, setUserRBACDetails);
      } else {
        message.error("Please provide valid login credentials!");
      }
    });
  };
  onFinishSubmit = (e) => {
    e.preventDefault();
    this.modalFormRef.props.form.validateFields((err, values) => {
      if (values && values.otp.length === 6) {
        const {
          setUserLoggedStatus,
          // history,
          setUserRBACDetails,
        } = this.props;

        this.props.form.validateFields((error, propValues) => {
          //if validated, call the login post api
          if (!error && propValues.username && propValues.password) {
            propValues.totp = values.otp;
            this.postSubmitData(
              propValues,
              setUserLoggedStatus,
              setUserRBACDetails
            );
          } else {
            message.error("Please provide valid login credentials!");
          }
        });
      } else {
        message.error("Please enter valid OTP !");
      }
    });
  };
  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    // localStorage.clear();

    const ConfigOptions = {
      maxCount: 1,
    };
    message.config(ConfigOptions);

    /**
     *function to submit the login credentials
     *
     * @param {Event} e the event from the form containing the form input values.
     * @memberof App.LoginForm
     */

    return (
      <>
        <Modal
          visible={this.state.qrModal}
          footer={false}
          maskClosable={false}
          closable={false}
          className="otp-modal"
        >
          <ModalFormWrapped
            wrappedComponentRef={this.saveModalFormRef}
            onSubmit={this.onFinishSubmit}
            mainValues={this.state}
          />
        </Modal>
        <Form onSubmit={this.handleSubmit.bind(this)} className="login-form">
          <div
            className="login-main-container"
            style={{ height: window.innerHeight - 25 }}
          >
            <div
              className="background-tile"
              style={{
                backgroundImage: `url(${bg})`,
              }}
            ></div>
            <div className="login-container">
              {/* <div className="login-div">
              <p>LOGIN</p>
            </div> */}

              <div className="login-logo">
                <img alt="logo" width={"100px"} height={"100px"} src={Logo} />
              </div>
              <div className="inputs">
                <Form.Item>
                  {getFieldDecorator("username", {
                    // rules: [
                    //   { required: true, message: "Please input your username!" }
                    // ]
                  })(
                    <Input
                      className="textbox"
                      prefix={
                        <Icon
                          type="user"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      placeholder="Username"
                    />
                  )}
                </Form.Item>
                <div className="dots">
                  . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .
                  . . .
                </div>
                {/* <div className="line"></div> */}
                <Form.Item>
                  {getFieldDecorator("password", {
                    // rules: [
                    //   { required: true, message: "Please input your Password!" }
                    // ]
                  })(
                    <Input.Password
                      className="textbox"
                      prefix={
                        <Icon
                          type="lock"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      placeholder="Password"
                    />
                  )}
                </Form.Item>
                <div className="dots">
                  . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .
                  . . .
                </div>
                <Form.Item>
                  {getFieldDecorator("captcha", {
                    rules: [
                      { required: true, message: "Please input Captcha!" },
                    ],
                  })(
                    <Input
                      className="textbox"
                      prefix={
                        <Icon
                          type="redo"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                      placeholder="Captcha"
                    />
                  )}
                  <LoadCanvasTemplate />
                </Form.Item>
                {/* <div className="line"></div> */}
              </div>
              <Form.Item
                style={{ margin: 0, padding: 0, lineHeight: "normal" }}
              >
                <div style={{ float: "right" }}>
                  {" "}
                  <p
                    style={{
                      margin: 0,
                      color: "#1890ff",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (this.state.isLoading) return;
                      this.props.form.getFieldValue("username")
                        ? this.handleShow.call(this, true)
                        : message.error(
                            "Please enter your username to reset your password!"
                          );
                    }}
                  >
                    Forgot Password
                  </p>
                </div>
              </Form.Item>
              <Form.Item
                style={{ margin: 0, padding: 0, lineHeight: "normal" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button button"
                >
                  LOGIN
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
        <ForgotPassword
          parentForm={this.props.form}
          userName={this.props.form.getFieldValue("username")}
          open={this.state.open}
          setClose={() => {
            this.handleShow.call(this, false);
            this.setState({ isLoading: false });
          }}
          submit={(values) =>
            this.postSubmitData(
              values,
              this.props.setUserLoggedStatus,
              this.props.setUserRBACDetails
            )
          }
        />
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  //////////////////////////////////////////////
  //#region arrival entry optimization selectors
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserLoggedStatus: (status) => dispatch(setUserLoggedStatus(status)),
    setAccessToken: (token) => dispatch(setAccessToken(token)),
    setRefreshToken: (token) => dispatch(setRefreshToken(token)),
    setUserRBACDetails: (
      id,
      name,
      territories,
      locationFeatures,
      nonLocationFeatures,
      userFeatures
    ) =>
      dispatch(
        setUserRBACDetails(
          id,
          name,
          territories,
          locationFeatures,
          nonLocationFeatures,
          userFeatures
        )
      ),
  };
};

class ModalForm extends React.Component {
  render() {
    const { onSubmit, mainValues } = this.props;
    return (
      <div className="reset-pw">
        <div className="header" style={{ textAlign: "center" }}>
          {mainValues.mfa_enabled === 0
            ? "Set up multi-factor authentication"
            : "OTP Verification"}
        </div>
        <div className="login-form">
          <Form
            name="reset_pw"
            // initialValues={{ remember: false }}
            onSubmit={onSubmit}
          >
            {mainValues.mfa_enabled === 0 ? (
              <>
                <Form.Item>
                  <div className="left-container" style={{ width: "100%" }}>
                    <p style={{ marginBottom: "0px" }}>
                      <b>Step 1 -</b> To set up your multi-factor
                      authentication, scan QR code.
                    </p>
                  </div>
                </Form.Item>
                <Form.Item
                  style={{ textAlign: "center", marginBottom: "10px" }}
                >
                  <QRCodeCanvas
                    size={256}
                    style={{
                      height: "auto",
                      maxWidth: "100%",
                      width: "30%",
                    }}
                    value={mainValues.qrCode}
                    viewBox={`0 0 256 256`}
                  />
                </Form.Item>
                <Form.Item>
                  <div className="left-container" style={{ width: "100%" }}>
                    <p style={{ marginBottom: "0px" }}>
                      <b>Step 2 -</b> Once you have scanned the QR code,
                      complete the set up by entering the OTP listed in your
                      Authenticator App.
                    </p>
                  </div>
                </Form.Item>
              </>
            ) : (
              <Form.Item>
                <div className="left-container">
                  <p style={{ marginBottom: "0px" }}>
                    <b>Step 1 -</b> Enter the OTP generated by your
                    authenticator app.
                  </p>
                </div>
              </Form.Item>
            )}
            <Form.Item
              name="otp"
              rules={[
                {
                  required: true,
                  message: "Please input OTP !",
                },
              ]}
              label="OTP"
              labelAlign="left"
              required
              style={{ marginBottom: "10px" }}
            >
              {this.props.form.getFieldDecorator("otp", {
                rules: [{ required: true, message: "Please input OTP !" }],
              })(
                <Input placeholder={"Enter OTP"} maxLength={6} size="default" />
              )}
            </Form.Item>
            <Form.Item>
              <div className="left-container" style={{ width: "100%" }}>
                <p
                  className="password-guideline"
                  style={{ marginBottom: "0px" }}
                >
                  <b>Step {mainValues.mfa_enabled === 0 ? "3" : "2"} - </b>
                  Click verify after entering OTP.
                </p>
              </div>
            </Form.Item>
            <Form.Item style={{ marginBottom: "0px", marginTop: "0px" }}>
              <div className="reset-btn-container" style={{ width: "100%" }}>
                <Button type="primary" size={"large"} block htmlType="submit">
                  Verify
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Login = Form.create({ name: "normal_login" })(LoginForm);
const ModalFormWrapped = Form.create()(ModalForm);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
